import {RouteConfig} from "vue-router";

const ladingErrorCustomerRoutes: Array<RouteConfig> = [
    {
        path: "lading-error",
        component: () => import("./List/index.vue"),
        name: "ladingErrorCustomer",
        meta: { title: "Đơn sự cố" }
    }
];

export default ladingErrorCustomerRoutes;